import React from "react";

const AdjacentZipsTable = ({ comparison }) => {
  if (!comparison || !comparison.length) return null;
  return (
    <div style={{ marginTop: 36 }}>
      <div className="abr-card-title">85251 vs nearby neighborhoods</div>
      <p className="abr-card-sub">
        The same buyer demand, measured in each adjacent zip - useful for seeing how 85251 stacks up.
      </p>
      <div className="abr-compare-wrap">
        <table className="abr-compare-table">
          <thead>
            <tr>
              <th style={{ width: "30%" }}>Zip</th>
              <th className="is-num">Median budget</th>
              <th className="is-num">Cash share</th>
              <th>What it tells you</th>
            </tr>
          </thead>
          <tbody>
            {comparison.map((row, idx) => (
              <tr className={row.you ? "is-you" : ""} key={idx}>
                <td className="is-metric">{row.zipLabel}</td>
                <td className="is-num" data-label="Median budget">{row.medianBudget}</td>
                <td className="is-num" data-label="Cash share">{row.cashShare}</td>
                <td className="is-read" data-label="Read">{row.read}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdjacentZipsTable;
